/**
 * useTranslation Hook
 * 
 * React hook for accessing translations in components
 */

import { useContext } from 'react';
import { I18nContext } from '../../contexts/I18nContext';

export interface UseTranslationReturn {
  t: (key: string, params?: Record<string, string | number>) => string;
  language: string;
  changeLanguage: (languageCode: string) => Promise<void>;
  direction: 'ltr' | 'rtl';
  isRTL: boolean;
}

/**
 * Hook to access translation functions and language state
 */
export const useTranslation = (): UseTranslationReturn => {
  const context = useContext(I18nContext);
  
  if (!context) {
    throw new Error('useTranslation must be used within I18nProvider');
  }
  
  return context;
};

